import React from "react";
import { ReactComponent as SearchIcon } from './icons/search.svg';
import { ReactComponent as TuneIcon } from './icons/tune.svg';
import { ReactComponent as CrossIcon } from './icons/cross.svg';
import { ReactComponent as DonlowadIcon} from './icons/download.svg';
import { ReactComponent as HomeIcon} from './icons/home-3.svg';
import { ReactComponent as CopyIcon} from './icons/copy.svg';
import { ReactComponent as TrashIcon} from './icons/trash-2.svg';
import { ReactComponent as EternalLinkIcon} from './icons/external-link.svg';
import { ReactComponent as PlusIcon} from './icons/plus.svg';
import { ReactComponent as ChevronDownIcon} from './icons/chevron-down.svg';



const Icon = {
    search: SearchIcon,
    tune: TuneIcon,
    cross: CrossIcon,
    download: DonlowadIcon,
    home: HomeIcon,
    copy: CopyIcon,
    trash: TrashIcon,
    externalLink: EternalLinkIcon,
    plus: PlusIcon,
    chevronDown: ChevronDownIcon,
};

export default Icon;